const React = require('react')
const Layout = require('@base/components/app/Layout').default

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}
